'use strict';

// ES6 class definition
export default class BviFilter {

  constructor() {
    let self = this;

    if( !document.querySelector('.bvifilter')) {
      return false;
    }

    self.initChangeListener()
      //console.log(self.filterItems);
  }


  go(debugMode = false) {

    let self = this;
    self._debugMode = debugMode;
    if( !document.querySelector('.filter') || document.querySelector('.filter--not-fixed') ) {
      return false;
    }

  }

  initChangeListener(self) {
    $('.bvifilter').on('change', function(e) {

      document.forms['bvifilter'].submit();
    });

  }

}
